import React from 'react';
import classnames from 'classnames';
import { RichText } from '../index';
import styles from './footnotes.module.scss';

export type FootnotesProps = {
  richtext: string;
  className?: string;
};

export const Footnotes: React.FC<FootnotesProps> = ({ richtext, className }) => (
  <RichText className={classnames(styles.footnotes, className)} mdString={richtext} wrapperElement="section" />
);
